'use client';
import { isDevelopment } from 'helpers/utils/environment';

export const useSubdomain = () => {

  const getSubdomain = () => {

    if (typeof window === 'undefined') {
      return undefined;
    }

    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > (isDevelopment() ? 1 : 2)) {
      return hostParts[0];
    }
    return undefined;
  };

  return getSubdomain();
}